<template>
  <div class="home" @click="showExist = false">
    <van-loading size="24px" class="wait" v-if="this.sample_type ===' '">加载中...</van-loading>
    <div v-else>
    <div class="userMessage">
      <i v-if="this.sample_type === 'childwes_zy' || this.access_token === null ? false : true" class="iconfont iconfanhui back" @click.stop="goback"></i>
      <van-icon v-if="this.sample_type === 'childwes_zy' || this.access_token === null ? false : true" class="ellipsis" name="ellipsis" @click.stop="showExist = !showExist" />
      <SideBar :show="showExist"></SideBar>
      <div class="icon">
        <i v-show="gender === 'male'" class="iconfont iconsexBoy"></i>
        <i v-show="gender === 'female'" class="iconfont iconsexGirl"></i>
      </div>
      <div>
        <p><span class="name">{{ name }} </span> 欢迎您</p>
        <p class="code">样本编号：{{ scode }}</p>
      </div>
    </div>

    <div class="main" v-if="gdb3">
      <!--祖源-->
      <!-- <div v-show="ape && (sample_type == 'wgs' || sample_type == 'asa' || sample_type == 'gsa' || sample_type == 'childwgs' || sample_type == 'childasa' || sample_type == 'childgsa')" class="source" @click="$router.push({path: '/source'})">祖源分析</div> -->
      <div v-show="ape && isShowSource.includes(sample_type) " class="source" @click="$router.push({path: '/source'})">祖源分析</div>
    </div>
    <div class="listBox">
      <div class="list">
        <div @click="$router.push({path: '/disease?activeTab=0'})">
          <p class="title">疾病风险</p>
          <div v-if="gdb3">
            <p class="message">高风险：{{ disease.num }}项</p>
            <p class="total">共计评估{{ disease.total }}项疾病</p>
          </div>
          <div v-if="gdb2">
            <p class="message">高风险：{{ disease.high }}项</p>
            <p class="total">共计评估{{ disease.sum }}项疾病</p>
          </div>
          <i class="iconfont iconxiayibu"></i>
        </div>
        <!-- <div @click="$router.push({path: '/inherit'})" v-show="sample_type !== 'childgsa' && sample_type !== 'chrgsa'"> -->
        <div @click="$router.push({path: '/inherit'})" v-show="!isShowInherit.includes(sample_type)">
          <p v-show="this.child === 1" class="title">单基因病（包含可治罕见病）</p>
          <p v-show="this.child === 0" class="title">单基因病</p>
          <div v-if="gdb3">
            <p class="message">携带项目：{{ inherit.num }}项</p>
            <p class="total">共计评估{{ inherit.total }}项遗传病</p>
          </div>
          <div v-if="gdb2">
            <p class="message">携带项目：{{ inherit.carry }}项</p>
            <p class="total">共计评估{{ inherit.sum }}项遗传病</p>
          </div>
          <i class="iconfont iconxiayibu"></i>
        </div>
        <!-- <div @click="$router.push({path: '/rare'})" v-show="(gdb3 && sample_type === 'childwes') ||(gdb3 && sample_type === 'childwgs') || (gdb3 && sample_type === 'childwes_zy')"> -->
        <div @click="$router.push({path: '/rare'})" v-show="gdb3 && isShowRara.includes(sample_type) ">
          <p class="title">可治性罕见病</p>
          <p class="message">携带项目：{{ rare.num }}项</p>
          <p class="total">共计评估{{ rare.total }}项遗传病</p>
          <i class="iconfont iconxiayibu"></i>
        </div>
        <!-- <div @click="$router.push({path: '/drug?activeTab=0'})" v-show="sample_type !== 'chrgsa' && sample_type !== 'childwes_zy'"> -->
        <div @click="$router.push({path: '/drug?activeTab=0'})" v-show="!isShowDrug.includes(sample_type)">
          <p class="title">精准用药</p>
          <div v-if="gdb3">
            <p class="message">需关注项目：{{ drug.num }}项</p>
            <p class="total">共计评估{{ drug.total }}项用药</p>
          </div>
          <div v-if="gdb2">
            <p class="message">需关注项目：{{ drug.follow }}项</p>
            <p class="total">共计评估{{ drug.sum }}项用药</p>
          </div>
          <i class="iconfont iconxiayibu"></i>
        </div>
        <div @click="$router.push({path: '/talent?activeTab=0'})" v-show="sample_type !== 'chrgsa'">
          <p class="title">特质基因</p>
          <div v-if="gdb3">
            <p class="message">需关注项目：{{ talent.num }}项</p>
            <p class="total">共计评估{{ talent.total }}项特质</p>
          </div>
          <div v-if="gdb2">
            <p class="message">需关注项目：{{ talent.follow }}项</p>
            <p class="total">共计评估{{ talent.sum }}项特质</p>
          </div>
          <i class="iconfont iconxiayibu"></i>
        </div>

      </div>
    </div>

    <div class="tab">
      <div v-if="gdb3">
        <van-tabs v-model="active" swipeable animated>
          <van-tab title="生活建议"><p v-for="(item, index) in life_suggestion" :key="index">{{ item }}</p></van-tab>
          <van-tab title="体检筛查"><p v-for="(item, index) in examine_suggestion" :key="index">{{ item }}</p></van-tab>
          <van-tab title="家人建议" v-if="child === 0"><p v-for="(item, index) in family_suggestion" :key="index">{{ item }}</p></van-tab>
        </van-tabs>
      </div>
      <div v-if="gdb2">
        <van-tabs v-model="active" swipeable animated>
          <van-tab title="生活建议">
            <p>建立营养而均衡的膳食结构，多食用富含蛋白质、维生
              素、低脂肪的饮食，多喝水，促进新陈代谢；注意含碘饮食
              的调节，维持碘元素的平衡；少吃富含草酸和嘌呤的食物如
              菠菜、猪肝等，避免痛风的发生；减少摄入烧烤、煎炒、炸
              、过于咸和油腻等食物；少食用坚硬粗糙的食物，不用或少
              用刺激性调味品；培养良好的进食习惯，按时进食，细嚼慢
              咽，热烫食物放置适温后食用，不要暴饮暴食。</p>
            <p v-for="(item, index) in suggest" :key="index">{{ item }}</p>
          </van-tab>
          <van-tab title="体检筛查">
            <p v-for="(item, index) in data.proposal.screening" :key="index">{{item.dsystem}}: {{item.examination}}</p>
          </van-tab>
          <van-tab title="家人建议" v-if="child === 0">
            <p v-if="data.proposal.Family.parents">您的父母: {{ data.proposal.Family.parents }}</p>
            <p v-if="data.proposal.Family.wife">您的爱人: {{ data.proposal.Family.wife }}</p>
            <p v-if="data.proposal.Family.brother">您的兄弟姐妹: {{ data.proposal.Family.brother }}</p>
            <p v-if="data.proposal.Family.children">您的子女: {{ data.proposal.Family.children }}</p>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { Dialog,Loading  } from 'vant'
import SideBar from '@/components/SideBarHome.vue'
export default {
  name: 'home',
  data () {
    return {
      isShowSource:['wgs','asa','gsa','childwgs','childasa','childgsa',], // 显示祖源的
      isShowRara:['childwes','childwgs','childwes_zy'], // 显示可治性罕见病的
      isShowInherit:['childgsa','chrgsa','child_core_array','childasa'], // 不显示单基因病的
      isShowDrug:['chrgsa','childwes_zy'], // 不显示精准用药药物的
      access_token:'',
      gdb3: false,
      gdb2: false,
      showExist: false,
      child: 0,
      active: 0,
      name: ' ',
      gender: '',
      scode: '',
      sample_type: ' ',
      value: '',
      option: [
        { text: '修改密码', value: 0 },
        { text: '退出登录', value: 1 }
      ],
      disease: {
        num: 0,
        total: 0
      },
      inherit: {
        num: 0,
        total: 0
      },
      rare: {
        num: 0,
        total: 0
      },
      drug: {
        num: 0,
        total: 0
      },
      talent: {
        num: 0,
        total: 0
      },
      ape: false,
      life_suggestion: [],
      examine_suggestion: [],
      family_suggestion: [],
      // gdb2
      data: {
        disease: {
          high: 0,
          low: 0,
          normal: 0,
          sum: 0
        },
        drug: {
          follow: 0,
          sum: 0
        },
        rare_disease: {
          carry: 0,
          sum: 0
        },
        inherit: {
          carry: 0,
          sum: 0
        },
        talent: {
          follow: 0,
          sum: 0
        },
        proposal: {
          Family: {
            brother: '',
            children: '',
            parents: '',
            wife: ''
          },
          screening: []
        }
      },
      dsystem: ['肿瘤', '心脑血管', '免疫系统', '消化系统', '内分泌及营养代谢', '呼吸系统', '泌尿生殖', '神经系统', '骨骼肌肉', '血液系统', '皮肤系统', '五官系统', '眼耳鼻喉'],
      highLevelDisease: [],
      detail: [
        {
          dsystem: '肿瘤',
          desc: '肿瘤疾病高风险者，需要限制高能量食物摄入，保持健康的体重，减少霉菌对食品的污染，避免长期接触致癌物，如煤烟、放射线等、预防环境污染、尽量减少房屋装修所致的污染。'
        },
        {
          dsystem: '免疫系统',
          desc: '免疫类疾病高风险者，需要保持乐观情绪，巨大的心理压力会导致对人体免疫系统有抑制作用的荷尔蒙成分增多，容易受到疾病的侵袭。以肠道双歧杆菌、乳酸杆菌为代表的有益菌群具有广谱的免疫原性，能刺激负责人体免疫的淋巴细胞分裂增殖，提高人体免疫力。'
        },
        {
          dsystem: '心脑血管',
          desc: '心脑血管疾病高风险者，应定期体检，若疾病发生，应按时规律服药，控制疾病指标，以免造成更大的危害。请去专业机构就医，不得随意换药、停药。'
        },
        {
          dsystem: '神经系统',
          desc: '神经类疾病风险高者，多食水果蔬菜，避免刺激性食物的摄入。保证足够的休息，找到合适的途径疏解心理压力。出现症状时，应及早就医。症状缓解后一定要在医生的指导下逐渐停药，切勿自行停药。'
        },
        {
          dsystem: '呼吸系统',
          desc: '呼吸系统高风险者，需要加大室内通风，保持空气流通；雾霾或扬尘天气时外出时佩戴口罩。'
        },
        {
          dsystem: '泌尿生殖',
          desc: '泌尿生殖类疾病高风险者，应减少生活中盐类、蛋白质摄入。规律生活，预防日常生活中毒性物质非常重要。定期体检，若疾病发生，应按时规律服药。'
        },
        {
          dsystem: '眼耳鼻喉',
          desc: '眼耳鼻喉类疾病高风险者，需要补充复合维生素，忌酒和刺激性食物。'
        },
        {
          dsystem: '皮肤系统',
          desc: '皮肤疾病系统高风险者，避免不良情绪刺激；避免过度劳累，不熬夜；保护皮肤、免受损伤。'
        },
        {
          dsystem: '消化系统',
          desc: '消化系统类疾病高风险者，应少量多餐； 进食含优质蛋白质及铁丰富的食物，有助于胃液分泌。用餐时避免有压力。'
        },
        {
          dsystem: '骨骼肌肉',
          desc: '如有家族疾病史者，体检时注意骨骼相关疾病的检查，平时加强骨骼保护，尽量减少突发性扭屈或提伸动作，注意枕头高度和床垫软硬适中。'
        },
        {
          dsystem: '内分泌及营养代谢',
          desc: '有早发性心血管病家族史者，或有家族性高脂血症患者要加强体检筛查。多食用包括油菜、芥菜、猕猴桃、香菇、蘑菇、木耳、核桃、薏米、红枣、山药等具有增强免疫力的食物。'
        },
        {
          dsystem: '血液系统',
          desc: '血液系统疾病高风险者，需根据体力情况，适当进行锻炼；注意调节情绪，避免情绪波动或精神刺激。'
        },
        {
          dsystem: '感染类疾病',
          desc: '感染类疾病高风险者，应注意生活习惯，尽量避免感染；多食水果、蔬菜等含维生素丰富的食物；戒酒、戒烟；根据自身情况选择适宜运动，运动量以不感疲劳为度，自觉稍微出汗即可，避免剧烈的体力活动。'
        }
      ],
      suggest: []
    }
  },
  components: {
    Dialog,
    SideBar,
    [Loading.name]:Loading 
  },
  methods: {
    goback () {
      this.$router.push({path: '/multiomics'})
    },
    getUser () {
      this.util.get(this.api.user, '', (success) => {
        this.name = success.name
        this.gender = success.gender
        this.scode = success.scode
        this.child = success.type
        this.sample_type = success.sample_type
        this.util.setLS(this.api.child, success.type)
        this.util.setLS(this.api.sample_type, success.sample_type)
        this.util.setLS(this.api.status, success.status)
        if (this.util.getLS(this.api.status) === 1) {
          this.gdb3 = true
          this.getQuantity()
          this.getSuggestions()
        } else {
          this.gdb2 = true
          this.getData()
          this.getHighLevelDisease()
        }
      })
    },
    getQuantity () {
      this.util.get(this.api.quantity, '', (success) => {
        this.disease = success.disease
        this.inherit = success.inherit
        if (this.child === 1) {
          this.rare = success.rare
        }
        this.drug = success.drug
        this.talent = success.talent
        if (success.ape) {
          this.ape = true
        } else {
          this.ape = false
        }
      })
    },
    getSuggestions () {
      this.util.get(this.api.suggestions, '', (success) => {
        this.life_suggestion = success.life_suggestion
        this.examine_suggestion = success.examine_suggestion
        this.family_suggestion = success.family_suggestion
      })
    },
    // signOut () {
    //   Dialog.confirm({
    //     message: '是否要退出当前账户？'
    //   }).then(() => {
    //     // on confirm
    //     localStorage.clear()
    //     this.$router.push('/login')
    //   }).catch(() => {
    //     // on cancel
    //   })
    // },
    // gdb2
    getData () {
      this.util.get1(this.api.report, '', (success) => {
        this.disease = success.disease
        this.inherit = success.inherit
        this.drug = success.drug
        this.talent = success.talent
        this.data = success
      })
    },
    getHighLevelDisease () {
      let that = this
      this.util.get1(this.api.highLevelDisease, '', (success) => {
        try {
          let obj = {}
          success.disease.map(function (item) {
            obj[item.dsystem || '肿瘤'] = ''
          })
          let suggest = this.getObjKeys(obj)
          this.dsystem.map(function (item) {
            if (suggest.indexOf(item) > -1) {
              that.detail.map(function (value) {
                if (value.dsystem === item) {
                  if (that.suggest.length < 3) {
                    that.suggest.push(value.desc)
                  }
                }
              })
            }
          })
          // console.log('suggest:', this.suggest)
        } catch (err) {
          console.log(err)
        }
      })
    },
    getObjKeys (obj) {
      let keys = []
      for (let p1 in obj) {
        if (obj.hasOwnProperty(p1)) {
          keys.push(p1)
        }
      }
      return keys
    }
  },
  created () {
    this.access_token = localStorage.getItem("access_token")
    // console.log(this.$route)
    let token = this.$route.query.token
    let lastUserName = this.util.getLS(this.api.username)
    if (token) {
      this.util.setLS(this.api.access_token, token)
    } else if (lastUserName) {
      // this.username = lastUserName
    }
    this.getUser()
  }
}
</script>

<style lang="scss">
  @import "../../assets/scss/functions";
  .home {
    width: 100%;
    .wait{
      position: relative;
      top: 3.5rem;
      left: 2.4rem;
      color: #000000;
    }
    .userMessage {
      position: relative;
      width: 100%;
      padding: pxToRem(90px) pxToRem(100px);
      background: linear-gradient(to right, #039ACD, #01D1E3);
      display: flex;
      flex-direction: row;
      align-items: center;

      .ellipsis {
        position: absolute;
        top: pxToRem(20px);
        right: pxToRem(30px);
        font-size: pxToRem(40px);
        color: #fff;
      }

      .back {
        position: absolute;
        top: pxToRem(20px);
        left: pxToRem(20px);
        font-size: pxToRem(40px);
        color: #fff;
      }
      // .icontuichu {
      //   position: absolute;
      //   top: pxToRem(20px);
      //   right: pxToRem(20px);
      //   font-size: pxToRem(40px);
      //   color: #fff;
      // }

      .icon {
        width: pxToRem(150px);
        height: pxToRem(150px);
        border: pxToRem(5px) solid #47dedd;
        line-height: pxToRem(150px);
        border-radius: 50%;
        text-align: center;
        margin-right: pxToRem(20px);
        background-color: #c7f5f5;

        .iconfont {
          font-size: pxToRem(100px);

          &.iconsexBoy {
            color: #00a0e8;
          }

          &.iconsexGirl {
            color: #e800db;
          }
        }
      }

      p {
        color: #fff;
        font-size: pxToRem(20px);

        &.code {
          font-size: pxToRem(25px);
        }

        .name {
          font-size: pxToRem(30px);
        }
      }
    }

    .main {
      width: 100%;
      padding: pxToRem(20px) pxToRem(30px);
      display: flex;
      justify-content: space-around;

      div {
        flex: 1;
        /*width: 48%;*/
        /*width: 22%;*/
        height: pxToRem(120px);
        /*height: pxToRem(158px);*/
        border-radius: pxToRem(20px);
        color: #fff;
        font-weight: bold;
        padding-top: pxToRem(20px);
        /*padding-left: pxToRem(30px);*/
        padding-left: pxToRem(10px);
        /*float: right;*/
        float: left;
        margin: 0 pxToRem(10px) pxToRem(20px);
        /*background-image: url("../../assets/images/home/home-main2.png");*/
        background-size: cover;
        background-position: center;

        /*&:first-child {
          float: left;
          background-image: url("../../assets/images/home/home-main1.png");
        }
        */
      }
      .source {
        background-image: url("../../assets/images/home/home-main2.png");
      }
      .assessment {
        background-image: url("../../assets/images/home/home-main1.png");
      }
      .currentIndex {
        background-image: url("../../assets/images/home/home-main2.png");
      }
    }

    .listBox {
      clear: both;
      width: 100%;
      padding: pxToRem(20px) pxToRem(30px);
      padding-bottom: 0;

      .list {
        background-color: #fff;
        border-radius: pxToRem(20px);
        padding: 0 pxToRem(40px);
        font-size: pxToRem(33px);

        > div {
          position: relative;
          padding: pxToRem(30px) 0;
          border-bottom: 1px solid #f8f8f8;

          &:last-child {
            border-bottom: none;
          }

          .message {
            color: #007aff;
            font-size: pxToRem(28px);
            margin-top: pxToRem(10px);
          }

          .total {
            text-align: right;
            font-size: pxToRem(20px);
          }

          .iconfont {
            position: absolute;
            top: pxToRem(70px);
            right: 0;
            color: #c1c1ca;
            font-size: pxToRem(50px);
          }
        }
      }
    }

    .tab {
      width: 100%;
      padding: pxToRem(20px) pxToRem(30px);

      .van-tabs--line {
        padding-top: pxToRem(70px);
        background-color: #fff;
        border-top-left-radius: pxToRem(20px);
        border-top-right-radius: pxToRem(20px);
        border-bottom-left-radius: pxToRem(20px);
        border-bottom-right-radius: pxToRem(20px);

        .van-tabs__line {
          background-color: transparent;
        }

        .van-tabs__wrap {
          height: pxToRem(90px);

          .van-tabs__nav--line {
            border-top-left-radius: pxToRem(20px);
            border-top-right-radius: pxToRem(20px);
          }

          .van-tab {
            line-height: pxToRem(90px);
          }
        }

        .van-tabs__content {
          padding: pxToRem(20px) 0;

          .van-tab__pane {
            padding: pxToRem(20px) pxToRem(30px);
          }
        }

        .van-tab--active {
          color: #007aff;
        }
      }

      .van-hairline--top-bottom::after {
        border-width: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue